import { HTTP as http } from "../../http";
import { bigDataLocationApiKey } from "../../services/config";

const prefix = "";

export default {
    saveAccessLocation: (data) => {
        return http.post(prefix + "saveAccessLocation", data);
    },

    getLocation: () => {
        return http.get("https://ipinfo.io?token="+bigDataLocationApiKey);
    },
};
